import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as AlarmApi from "api/student/v2/alarm.api";
import AlarmComponent from "./Index.component";
import { notificationListener } from "helpers/Firebase.helper";

const IndexContainer = (props: any) => {
  const location = useLocation();

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const searchParams = new URLSearchParams(location.search);
  const limit = 10;
  const [page, setPage] = useState(1);

  const getList = async () => {
    setIsLoading(true);
    const result = await AlarmApi.getAlarmList(page, limit, true);

    if (result?.list) {
      setList(result.list);
      setPage(page + 1);
    }
    setIsLoading(false);
  };

  const onClickCheckNotification = async (item: any) => {
    // // if (item.isRead === 0) {
    // //   await AlarmApi.updateReadInfo(item.id, {});
    // // }

    // if (item.type === "action") {
    //   if (item.action === "reload") {
    //     window.location.reload();
    //   }
    // }
    // if (item.type === "link") {
    //   if (item.linkUrl) {
    //     window.location.href = item.linkUrl;
    //   }
    // }
  };

  useEffect(() => {
    getList();
    notificationListener.on("notification", getList);

    return () => {
      notificationListener.off("notification", getList);
    };
  }, [page]);

  return (
    <AlarmComponent
      isLoading={isLoading}
      list={list}
      onClickCheckNotification={onClickCheckNotification}
      // pagination
      limit={limit}
      page={page}
      setPage={setPage}
    />
  );
};

export default IndexContainer;
